/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { SidePanelContext } from '../context/SidePanelContext';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import ShareToSlackPanel from './ShareToSlackPanel';
import IntegrationConnectionResolver from '../utils/IntegrationConnectionResolver';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ShareToSlackPanelLoader extends Component {
  constructor(props) {
    super(props);
    this.showSidePanel = (description, recordToShare, placeIdentifier) => {
      this.setState({
        description,
        recordToShare,
        placeIdentifier,
        showPanel: true
      });
    };
    this.hideSidePanel = () => {
      this.setState({
        showPanel: false
      });
    };
    this.state = {
      showPanel: false,
      recordToShare: undefined,
      description: undefined,
      placeIdentifier: undefined,
      isIntegrationInstalled: false
    };
  }
  componentDidMount() {
    IntegrationConnectionResolver.isConnected().then(isIntegrationInstalled => this.setState({
      isIntegrationInstalled
    }));
  }
  render() {
    return /*#__PURE__*/_jsxs(SidePanelContext.Provider, {
      value: {
        showSidePanel: this.showSidePanel,
        isIntegrationInstalled: this.state.isIntegrationInstalled
      },
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), this.props.children, this.state.showPanel && /*#__PURE__*/_jsx(ShareToSlackPanel, {
        recordToShare: this.state.recordToShare,
        closePanel: this.hideSidePanel,
        description: this.state.description,
        placeIdentifier: this.state.placeIdentifier
      })]
    });
  }
}
ShareToSlackPanelLoader.propTypes = {
  children: PropTypes.node.isRequired
};
export default ShareToSlackPanelLoader;